import * as React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import { insertCoin } from "playroomkit"

//https://github.com/asadm/playroom-docs/tree/main/examples/drawinggame
//https://gulzar.app.100ms.live/meeting/krc-nwj-yeh
const rootElement = document.getElementById("root")!
insertCoin().then(()=>{ 
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )  
})
